<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
@if (date && !version) {
<div class="task_properties" fxLayout="row" fxLayoutAlign="start center">
  <span class="task_properties_title">{{ label }}</span>
  <span class="task_properties_value">-</span>
</div>
} @else if (date && version) {
<div class="task_properties" fxLayout="row" fxLayoutAlign="start center">
  <span class="task_properties_title">{{ label }}</span>
  <span class="task_properties_value">{{ formattedDate + ' (Version ' + version + ')' }}</span>
</div>
} @else if (text) {
<div class="task_properties" fxLayout="row" fxLayoutAlign="start center">
  <span class="task_properties_title">{{ label }}</span>
  <span class="task_properties_value">{{ text }}</span>
</div>
}
